import * as React from "react";
const SvgArrowRight = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 9 15" {...props}><path fillRule="evenodd" d="m9.046 7.543.004-.003L2.923.986h-3L6.05 7.54l.01.003H6.05l-6.127 6.554h3L9.05 7.543z" /></svg>;
export default SvgArrowRight;